module.exports = __webpack_public_path__ + "img/istore_icon_V1.e6304d99.svg";